module.exports = __webpack_public_path__ + "media/whale sharks/whale_hand-01c1e4e0.jpg";